import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Margin } from 'components/ui'

import { Order } from '../../../stores/entity/Order'
import { OrderPaymentStatus, OrderStatus } from '../../../types'
import { getOrderItemPageKey } from '../../../utils'
import { OrderItemStatusHeader } from './OrderItemStatusHeader/OrderItemStatusHeader'
import { OrderStatusAccepted } from './Statuses/Accepted/OrderStatusAccepted'
import { OrderStatusActivated } from './Statuses/OrderStatusActivated'
import { OrderStatusCreated } from './Statuses/OrderStatusCreated'
import { OrderStatusDeclined } from './Statuses/OrderStatusDeclined'
import { OrderStatusDraft } from './Statuses/OrderStatusDraft'
import { OrderStatusReadyToActivate } from './Statuses/OrderStatusReadyToActivate'
import { OrderStatusRemark } from './Statuses/OrderStatusRemark'
import { OrderStatusWaitingPayment } from './Statuses/OrderStatusWaitingPayment'

type OrderItemStatusViewProps = {
  order: Order
  paymentStatus: OrderPaymentStatus | null
  hasErrorWithPayment?: boolean
}

export const OrderItemStatusView = observer(
  ({ order, paymentStatus, hasErrorWithPayment }: OrderItemStatusViewProps) => {
    const { t } = useTranslation()

    const orderStatusItem: Map<OrderStatus, JSX.Element> = new Map([
      [OrderStatus.draft, <OrderStatusDraft key={OrderStatus.draft} order={order} />],

      [
        OrderStatus.waitingPayment,
        <OrderStatusWaitingPayment
          key={OrderStatus.waitingPayment}
          paymentStatus={paymentStatus}
          hasErrorWithPayment={hasErrorWithPayment}
          order={order}
        />,
      ],

      [OrderStatus.created, <OrderStatusCreated key={OrderStatus.created} order={order} />],

      [OrderStatus.remarkFromActivate, <OrderStatusRemark key={OrderStatus.remarkFromActivate} order={order} />],
      [OrderStatus.remarkFromCreated, <OrderStatusRemark key={OrderStatus.remarkFromCreated} order={order} />],

      [OrderStatus.declined, <OrderStatusDeclined key={OrderStatus.declined} />],

      [OrderStatus.accepted, <OrderStatusAccepted key={OrderStatus.accepted} order={order} />],

      [OrderStatus.readyActivate, <OrderStatusReadyToActivate key={OrderStatus.readyActivate} order={order} />],

      [OrderStatus.pickPointCreated, <OrderStatusActivated key={OrderStatus.pickPointCreated} />],
    ])

    return (
      <Margin mb={24}>
        <OrderItemStatusHeader
          type="success"
          title={t(getOrderItemPageKey('step'), { count: 1 })}
          subTitle={t(getOrderItemPageKey('Создана'))}
          isActive={order.status === OrderStatus.draft}
        />

        {orderStatusItem.get(order.status)}
      </Margin>
    )
  },
)
